<template>
  <b-form-checkbox
    id="report_per_ledger"
    name="report_per_ledger"
    v-model="per_ledger"
    switch>
    Per Ledger
  </b-form-checkbox>
</template>

<script>
export default {
  name: 'ReportPerLedger',

  computed : {
    per_ledger : {
      get : function(){
        return this.$store.state.report.per_ledger;
      },

      set : function(v){
        this.$store.commit('set_report_per_ledger', v);
      }
    }
  }
}
</script>

<style scoped>
div{
  position: absolute;
  bottom: 0;
  font-size: 0.8em;
}
</style>
